// extracted by mini-css-extract-plugin
module.exports = {"container":"AcceptCGA_container__1h7uE","breederContainer":"AcceptCGA_breederContainer__3dHJV"};